import React from 'react';
import Hero from '../components/Hero';
import CallNow from '../components/CallNow';
import Welcome from '../components/Welcome';
import RoomsPreview from '../components/RoomsPreview';
import Location from '../components/Location';

/**
 * Home Page Component
 * Main landing page with all sections
 */
const Home = () => {
  return (
    <main className="pt-0">
      <Hero />
      <CallNow />
      <Welcome />
      <RoomsPreview />
      <Location />
    </main>
  );
};

export default Home;

